import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { CommonServiceService } from "../../../component/common/common-service.service";
import { ClinicComponent } from "../clinic/clinic.component";
import { ServiceComponent } from "../service/service.component";
import { RoleComponent } from "../role/role.component";
import { OrganizationComponent } from "../organization/organization.component";
import { TimeslotComponent } from "../timeslot/timeslot.component";
import { MedicalHistoryComponent } from "../medical-history/medical-history.component";
import { ModuleComponent } from "../module/module.component";
import { ActionComponent } from "../action/action.component";
import { LoaderComponentMasterData } from "../../../shared/component/loader-data/loader.component";
import { SpecializeComponent } from "../specialize/specialize.component";
import { TagComponent } from "../tags/tags.component";
import { NoteComponent } from "../note/note.component";
import { ComplaintComponent } from "../complaint/complaint.component";
import { DiagnoseComponent } from "../diagnose/diagnose.component";
import { InvestigationComponent } from "../investigation/investigation.component";
import { ObservationComponent } from "../observation/observation.component";
import { ProcedureComponent } from "../procedure/procedure.component";
import { DrugsComponent } from "../drugs/drugs.component";
import { RoleActionComponent } from "../role-action/role-action.component";
import { PromotionCodeComponent } from "../promotion-code/promotion-code.component";
import { MyDatePickerModule } from "mydatepicker";
import { AdminPostComponent } from "../admin-post/admin-post.component";
import { SubscriptionComponent } from "../subscriptionMaster/subscriptionMaster.component";
import { SystemInfoComponent } from "../system-info/system-info.component";

@NgModule({
  imports: [
    CommonModule,
    MyDatePickerModule,
    FormsModule,
    RouterModule.forChild([
      { path: "clinic", component: ClinicComponent },
      { path: "service", component: ServiceComponent },
      { path: "organization", component: OrganizationComponent },
      { path: "history", component: MedicalHistoryComponent },
      { path: "timeslot", component: TimeslotComponent },
      { path: "specialize", component: SpecializeComponent },
      { path: "tags", component: TagComponent },
      { path: "note", component: NoteComponent },
      { path: "adminpost", component: AdminPostComponent },
      { path: "procedure", component: ProcedureComponent },
      { path: "subscription", component: SubscriptionComponent },
      { path: "drug", component: DrugsComponent },
      { path: "promotioncode", component: PromotionCodeComponent },
      { path: "sysinfo", component: SystemInfoComponent }
    ])
  ],
  providers: [CommonServiceService],
  declarations: [
    ClinicComponent,
    SpecializeComponent,
    ServiceComponent,
    OrganizationComponent,
    TimeslotComponent,
    MedicalHistoryComponent,
    RoleComponent,
    LoaderComponentMasterData,
    ModuleComponent,
    ActionComponent,
    NoteComponent,
    ComplaintComponent,
    DiagnoseComponent,
    InvestigationComponent,
    ObservationComponent,
    ProcedureComponent,
    SubscriptionComponent,
    DrugsComponent,
    RoleActionComponent,
    PromotionCodeComponent,
    TagComponent,
    AdminPostComponent,
    SystemInfoComponent
  ],
  exports: [RouterModule]
})
export class MasterRouteModule {}



// WEBPACK FOOTER //
// ./src/app/section/master/master-route/master-route.module.ts